import { Link, useSearchParams } from 'react-router-dom';
import { SearchBar } from '../components/search/SearchBar';
import { categoryLabel } from '../data/categories';
import { searchArticles } from '../lib/search';
import { PROFILE_LABEL, type Profile } from '../types/profile';

export function SearchPage({ profile }: { profile?: Profile }) {
  const [params] = useSearchParams();
  const query = params.get('q')?.trim() ?? '';
  const effectiveProfile: Profile = profile ?? 'student';
  const results = searchArticles(query, effectiveProfile);

  return (
    <main className="page-shell search-page">
      <div className="search-page-heading">
        <p className="eyebrow">Busca</p>
        <h1>{query ? `Resultados para “${query}”` : 'Buscar no Centro de Ajuda'}</h1>
        <p className="lead">Mostrando conteúdo disponível para {PROFILE_LABEL[effectiveProfile]}.</p>
        <SearchBar initialQuery={query} autoFocus={!query} />
      </div>

      {!query ? (
        <section className="empty-state compact-empty">
          <h2>Digite o que você quer aprender ou resolver.</h2>
          <p>Você pode buscar por uma tarefa, tela, dúvida ou termo do Personagrama.</p>
        </section>
      ) : results.length > 0 ? (
        <section aria-live="polite" aria-label="Resultados da busca">
          <p className="result-count">{results.length} {results.length === 1 ? 'resultado' : 'resultados'}</p>
          <div className="search-results">
            {results.map((result) => (
              <Link key={result.id} className="search-result-card" to={result.route}>
                <div className="search-result-meta">
                  <span>{PROFILE_LABEL[result.profile]}</span>
                  <span>{result.kind === 'faq' ? 'Pergunta frequente' : categoryLabel(result.category)}</span>
                </div>
                <h2>{result.title}</h2>
                <p>{result.description}</p>
                <span className="card-link">{result.kind === 'faq' ? 'Ver resposta →' : 'Abrir artigo →'}</span>
              </Link>
            ))}
          </div>
        </section>
      ) : (
        <section className="empty-state compact-empty" aria-live="polite">
          <h2>Não encontramos uma resposta para essa busca.</h2>
          <p>Tente outras palavras, consulte as categorias ou use um termo mais curto.</p>
          <Link className="button-link" to={`/${effectiveProfile === 'student' ? 'aluno' : effectiveProfile}`}>
            Ver categorias de {PROFILE_LABEL[effectiveProfile]}
          </Link>
        </section>
      )}
    </main>
  );
}
